import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Wrapper } from "modules/theme";
import SettingsSidebar from "../../sidebar";
import { Alert, confirm } from "modules/theme";
import { CenterFlexRow, BackButton } from "../../styles";
import APIManager from "modules/common/apiManager";
import { Row, RowTitle, Box, BoxName, Divider } from "../../main/styles";
import { BarItems } from "modules/theme";
//import { DataWrapperClass } from '../styles';
import { Modal } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";
import { PerPage } from "helpers/system-config";
import {
  ModalTrigger,
  Pagination,
  Button,
  FormControl,
  ActionButtons,
  Table,
  Label,
  Tip,
  DataWithLoader,
  FormGroup,
  ControlLabel,
  ReportPagination,
  ImportFile,
  SeachForm,
  DataWrapperClass,
  ButtonCommonTheme,
  Icon,
  SettingDropdownMenu,
} from "modules/theme";
import CountryAddEdit from "./CountryAddEdit";
import { leftSidebarType, modalType } from "../../../../../helpers/dotenv";
import { MdOutlineAdd } from "react-icons/md";
import { OverflowClass } from "modules/theme";

class Country extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.moduleName = "Country";
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.state = {
      listData: [],
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      loading: false,
      editData: null,
      showHide: false,
      modalType: modalType,
      search: "",
      MasterChecked: false,
      SingleChecked: false,
      SelectedList: [],
      ary: [],
    };
  }

  onMasterCheck(e) {
    let tempList = this.state.listData;
    // Check/ UnCheck All Items
    tempList.map((listData) => (listData.selected = e.target.checked));
    //Update State
    this.setState({
      MasterChecked: e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  onItemCheck(e, item) {
    let tempList = this.state.listData;
    tempList.map((user) => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });
    //To Control Master Checkbox State
    const totalItems = this.state.listData.length;
    const totalCheckedItems = tempList.filter((e) => e.selected).length;
    // Update State
    this.setState({
      MasterChecked: totalItems === totalCheckedItems && e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  deleteAllData(e) {
    let _this = this;
    e.preventDefault();
    // const ary = [];
    const list = this.state.SelectedList.map((data) => {
      // ary = data._id;
      this.state.ary.push(data._id);
      // this.setState({ ary: data._id });
    });
    this.mAPI.sendPostAPI(
      `setting/country/multiple/usingIds`,
      {
        ids: this.state.ary,
      },
      (data) => {
        this.getCountry(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.contactId
        );
        Alert.success(`${this.moduleName} is deleted.`);
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data}`);
      },
      `private`,
      {},
      "PUT"
    );
  }

  search(e) {
    let teamList = this.state.listData;
    teamList.map((e) => (e.selected = false));
    this.setState({
      SelectedList: [],
      MasterChecked: false,
      SingleChecked: false,
      listData: teamList,
      currentPage: 1
    });
    let value;
    value = e.target.value;
    const reg = /^[a-zA-Z0-9_ @]*$/;
    if (reg.test(value)) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.setState({ search: value });
        this.getCountry(1, this.state.perPageCount, value);
      }, 500);
    }
  }

  componentDidMount() {
    this.getCountry(
      this.state.currentPage,
      this.state.perPageCount,
      this.state.search
    );
  }

  getCountry(page = 1, perPage = "", searchText = "") {
    var that = this;
    this.setState({ loading: true });
    perPage = perPage || this.state.perPageCount;
    this.mAPI.sendGetAPI(
      `setting/country?limit=${perPage}&page_no=${page}&search=${searchText}&orderBy=create_at&order=DESC`,
      (data) => {
        this.setState({ loading: false });
        if (data && data.data) {
          that.setState({
            listData: data.data,
            total: data.count || 0,
            SelectedList: [],
            ary: [],
          });
        } else {
          that.setState({ listData: [] });
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        // if (data) {
        //   Alert.success(`${data.message}`);
        // } else {
        //   Alert.error(`${error}`);
        // }
      }
    );
  }

  onPaginationChange(page) {
    this.setState({ currentPage: page });
    // this.getCountry(page);
    this.getCountry(page, "", this.state.search);
  }

  onPerPageChooser(perPage) {
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getCountry(1, perPage, this.state.search);
  }

  closeModal(isUpdated) {
    this.setState({ showHide: false });
    if (isUpdated) {
      this.getCountry(
        this.state.currentPage,
        this.state.perPageCount,
        this.state.search
      );
    }
  }
  openModal(data) {
    if (data) {
      this.setState({ showHide: true, editData: data });
    } else {
      this.setState({ showHide: true, editData: undefined });
    }
  }

  remove(array, key, value) {
    const index = array.findIndex((obj) => obj[key] === value);
    return index >= 0
      ? [...array.slice(0, index), ...array.slice(index + 1)]
      : array;
  }

  deleteCountry(tCountry) {
    var that = this;
    this.mAPI.sendPostAPI(
      `setting/country/${tCountry._id}`,
      undefined,
      (data) => {
        let tD = that.state.listData;
        tD = that.remove(tD, "_id", tCountry._id);
        that.setState({ listData: tD });
        that.getCountry(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.search
        );
        Alert.success(`The ${tCountry.name} is deleted.`);
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data.message}`);
      },
      "private",
      {},
      "DELETE"
    );
  }

  onChange() {}

  onSingleChange(e, company) {}

  editCountry(tCountry) {
    return (
      /* <Tip text={`${'Edit'}`} key={`${'Edit'}`}>
        <Button
          btnStyle="link"
          onClick={() => this.openModal(tCountry)}
          style={{ verticalAlign: 'middle' }}
          icon="edit"
        ></Button>
      </Tip> */
      <ButtonCommonTheme
        type="edit"
        editOnClick={() => this.openModal(tCountry)}
      />
    );
  }

  renderActions(tCountry) {
    return (
      <ActionButtons>
        {this.editCountry(tCountry)}
        {/* <Tip text={`${'Delete'}`} key={`${'Delete'}`}>
          <Button
            btnStyle="link"
            onClick={e =>
              confirm().then(e => {
                this.deleteCountry(tCountry, e);
              })
            }
            style={{ verticalAlign: 'middle' }}
          // icon={'user-minus'}
          >
            <FiTrash2 style={{ fontSize: '14px' }} />
          </Button>
        </Tip> */}
        <ButtonCommonTheme
          type="delete"
          deleteOnClick={(e) =>
            confirm().then((e) => {
              this.deleteCountry(tCountry, e);
            })
          }
        />
      </ActionButtons>
    );
  }

  importContact(file) {
    let formData = new FormData();
    formData.append("file", file);
    // formData.append('contactListId', this.state.contactId);
    return formData;
  }

  renderActionBar() {
    let _this = this;
    /*  const importTrigger = (
      <Button btnStyle="default" size="small">
        <img src='/images/plus.png' style={{ width: '12px' }} />
      </Button>
    ); */
    const ImportTrigger = ({ onClick }) => {
      return <ButtonCommonTheme type="add" addOnClick={onClick} />;
    };
    return (
      <span style={{ display: "flex", whiteSpace: "nowrap" }}>
        {/* <SeachForm>
          <FormControl
            type="text"
            placeholder={'Search...'}
            onChange={e => this.search(e)}
            value={this.state.searchValue}
            autoFocus={false}
          />
        </SeachForm> */}
        {/* <FormControl
          type="text"
          placeholder={'Type to search'}
          onChange={e => this.search(e)}
          value={this.state.searchValue}
          autoFocus
        /> */}
        <ModalTrigger
          title="Country"
          trigger={<ImportTrigger />}
          size="md"
          showHide={this.state.showHide}
          closeModal={this.closeModal}
          openModal={this.openModal}
          dialogClassName={this.state.modalType}
        >
          <CountryAddEdit
            size="small"
            update={() => this.setState({ currentPage: 1 })}
            isEdit={false}
            editData={this.state.editData}
            closeModal={this.closeModal}
            modalType={this.state.modalType}
          />
        </ModalTrigger>

        <ImportFile
          apiUrl={`setting/country/import`}
          fetchData={this.importContact}
          importDone={() => {
            _this.setState({ loading: true });
            setTimeout(() => {
              _this.onPerPageChooser(_this.state.perPageCount);
            }, 3000);
          }}
          urlDownload={`country.csv`}
        ></ImportFile>
      </span>
    );
  }

  render() {
    const { __ } = this.context;
    const breadcrumb = [
      { title: __("Settings"), link: "/settings" },
      { title: __("Country"), link: "/settings/Country" },
    ];

    const mainContent = (
      <DataWrapperClass>
        <OverflowClass style={{ overflow: "auto" }}>
          <Table whiteSpace="nowrap" bordered hover>
            <thead>
              <tr>
                <th onClick={this.onClick}>
                  <FormControl
                    componentClass="checkbox"
                    checked={this.state.MasterChecked}
                    onChange={(e) => this.onMasterCheck(e)}
                  />
                </th>
                <th>{__("Flag")}</th>
                <th>{__("Country")}</th>
                <th>{__("Country Code")}</th>
                <th>{__("Actions")}</th>
              </tr>
            </thead>
            <tbody id="Country">
              {this.state.listData.map((tCountry) => (
                <tr key={tCountry._id}>
                  <td onClick={this.onClick}>
                    <FormControl
                      componentClass="checkbox"
                      checked={tCountry.selected}
                      onChange={(e) => this.onItemCheck(e, tCountry)}
                    />
                  </td>
                  <td>{tCountry.emoji}</td>
                  <td className="text-primary">{tCountry.name}</td>
                  <td>{tCountry.phone_code}</td>
                  <td>{this.renderActions(tCountry)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </OverflowClass>
      </DataWrapperClass>
    );

    return (
      <div className="heightClass">
        <DataWrapperClass>
          <Wrapper
            header={<Wrapper.Header breadcrumb={breadcrumb} />}
            heading={
              // <ControlLabel>{`Country Code`}</ControlLabel>
              <CenterFlexRow className="header-label">
                <Link className="btn-back" to={`/settings`}>
                  <BackButton>
                    <Icon icon="angle-left" size={20} />
                  </BackButton>
                </Link>
                <ControlLabel>{`Country Code`}</ControlLabel>
              </CenterFlexRow>
            }
            actionBar={
              <Wrapper.ActionBar
                left={
                  <div style={{ display: "flex" }}>
                    {/* <ControlLabel>{`Country Code (${this.state.total || 0})`}</ControlLabel> */}
                    <SeachForm>
                      <FormControl
                        type="text"
                        placeholder={"Search..."}
                        onChange={(e) => this.search(e)}
                        value={this.state.searchValue}
                        autoFocus={false}
                        style={{ marginRight: "15px" }}
                      />
                    </SeachForm>
                    {this.state.SelectedList.length > 0 ? (
                      /* <Tip text={`${'Delete'}`} key={`${'Delete'}`}>
                        <Button
                          btnStyle="danger"
                          size="small"
                          onClick={e =>
                            confirm().then(e => {
                              this.deleteAllData(e);
                            })
                          }
                          style={{
                            verticalAlign: 'middle',
                            marginLeft: '10px'
                          }}
                        // icon={'user-minus'}
                        >
                          <FiTrash2
                            style={{ fontSize: '14px', marginBottom: '-3px' }}
                          />
                        </Button>
                      </Tip> */
                      <ButtonCommonTheme
                        type="deleteAll"
                        checkboxDeleteOnClick={(e) =>
                          confirm().then((e) => {
                            this.deleteAllData(e);
                          })
                        }
                      />
                    ) : (
                      ""
                    )}
                  </div>
                }
                // right={actionBarRight}
                right={this.renderActionBar()}
              />
            }
            footer={
              <ReportPagination
                count={this.state.total}
                onPaginationChange={this.onPaginationChange}
                onPerPageChooser={this.onPerPageChooser}
                currentPage={this.state.currentPage}
                perPage={this.state.perPageCount}
              />
            }
            leftSidebar={<SettingDropdownMenu />}
            showLeftSideBar={true}
            content={
              <div>
                <DataWithLoader
                  data={mainContent}
                  loading={this.state.loading}
                  size={this.state.listData.length}
                  count={this.state.listData.length}
                  emptyText="Save Country"
                  emptyImage="/images/Country-empty.png"
                />
              </div>
            }
          />
        </DataWrapperClass>
      </div>
    );
  }
}

Country.contextTypes = {
  __: PropTypes.func,
};

export default Country;



// WEBPACK FOOTER //
// src/modules/screens/settings/Country/components/Country.js